import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { useTypesDonneeQuery } from "../../cdsApiSlice";
import { deleteCustomMeteData, Metadonees, setSource } from "../../cdsSlice";
import { Boolean } from "./fields/boolean";
import { List } from "./fields/list";
import { Text } from "./fields/text";
import { Metadonee } from "./metadonne";
import { useNavigate, useParams } from "react-router-dom";
import RenderLoading from "./RendorLoading";
import { Message } from "primereact/message";
import ButtonsNavigate from "./BottomButtonNaviage";
import ErrorSourceExterne from "./ErrorSourceExterne";
import { Regex } from "./fields/regex";
import { regexValidator } from "../../../../utils/regexValidator";
import { LabelsSelectors, useLabelsSelectors } from '@kosmos/shared';

interface SourceProps {
  add: () => void;
  minus: () => void;
}

interface Error {
  uri: {
    regex: boolean;
    required: boolean;
  };
  typeDeDonnee: boolean;
  formatDeDonnee: boolean;
}

interface IMetaData {
  name: string;
  value: string;
  increment?: number;
}

export const Source = ({ add, minus }: SourceProps) => {
  const EMPTY_STRING = "";
  const RECURSIVE_SOURCE = "source_recursif";
  const source: any = useAppSelector((state) => state.cds.source);
  const protocole = useAppSelector((state) => state.cds.protocole);
  const { data: typesDonnee, ...TypesDonneeStatus } = useTypesDonneeQuery();
  const dispatch = useAppDispatch();
  const [protocoleData, setProtocoleData] = useState<any[]>([]);
  const [metaProtocole, setMetaProtocole] = useState<any[]>([]);
  const [errorProtocoleData, setErrorProtocoleData] = useState<boolean>(false);
  const [typeData, setTypeData] = useState<any[]>([]);
  const [formatData, setFormatData] = useState<any[]>([]);
  const [errorDialog, setErrorDialog] = useState<boolean>(false);
  const [metaDatas, setMetaDatas] = useState<IMetaData[]>([]);
  const [lengthTableMetadata, setLengthMeta] = useState<number>(0);
  const [formMetaData, setFormMetaData] = useState<boolean>(true);
  const [errorMetaData, setErrorMetaData] = useState<boolean>(false);
  const [uriDesc, setUriDesc] = useState<string>(EMPTY_STRING);
  const { id } = useParams();
  const navigate = useNavigate();
  const [metaDataDuplicated, setMetaDataDuplicated] = useState<string[]>([]);
  const [newMetaIsDuplicated, setNewMetaIsDuplicated] =
    useState<boolean>(false);
  const [errorForm, setErrorForm] = useState<Error>({
    uri: {
      regex: false,
      required: false,
    },
    typeDeDonnee: false,
    formatDeDonnee: false,
  });
  const { selectedLabels, validate: validateLabels, labels } = useLabelsSelectors();

  useEffect(() => {
    const labelsName = labels ? labels.map((l) => l.id) : [];
    const metasAndLabelsName = [...metaDatas.map((m) => m.name), ...labelsName];
    setMetaDataDuplicated(
      metasAndLabelsName.filter(
        (item, index) => metasAndLabelsName.indexOf(item) < index
      )
    );
  }, [labels]);

  const checkMetaDataDuplicated = (newMetadataName: string) => {
    const labelsName = labels ? labels.map((l) => l.id) : [];
    const metasAndLabelsName = [...metaDatas.map((m) => m.name), ...labelsName];
    return metasAndLabelsName.includes(newMetadataName);
  };

  useEffect(() => {
    if (
      metaProtocole &&
      metaProtocole.length === 0 &&
      source.protocoleDatas.length > 0
    ) {
      setMetaProtocole(source.protocoleDatas);
    }
    if (source.formatDeDonnee && formatData.length === 0) {
      updateFormatData(source.typeDeDonnee.name);
    }
    if (source?.uri) {
      regexNom(source.uri);
    }
    if (source.CustomMetaData.length > 0 && metaDatas.length === 0) {
      let tmpMetaData = source.CustomMetaData.map((val: any, i: number) => ({
        name: val.name,
        value: val.value,
        increment: i,
      }));
      setMetaDatas(tmpMetaData);
      setLengthMeta(tmpMetaData.length);
    }
  }, [protocoleData, source, typesDonnee]);

  const updateFormatData = (value: string) => {
    if (typesDonnee) {
      setFormatData(
        typesDonnee
          .filter((i: any) => i.nom === value)
          .map((i: any) => i.refFormats)[0]
          .map((i: any) => ({ name: i.nom }))
      );
    }
  };

  const updateMetaProtocole = (nom: string, variable: any) => {
    setMetaProtocole((prev) => {
      let tmp = prev?.filter((item) => item.nom != nom);
      if (!tmp) tmp = [];
      tmp?.push({ nom: nom, valeur: variable });
      return tmp;
    });
  };

  const idMetaData = (val: string, i: number, param: any): string => {
    if (val === "value" || val === "name") {
      return param ? val + param : val + i;
    }
    return EMPTY_STRING;
  };

  useEffect(() => {
    if (protocole && source.protocoleDatas.length === 0) {
      const filteredData = protocole.filter(
        (item) => item.nom === source.protocole
      )[0].refMetadonnees;
      setProtocoleData(
        filteredData.map((item) => {
          if(item.nom === "source_motif_noms_fichiers") 
          return {
            ...item,       
            type:"regex"
          }
          return item
        })
      );
    }

    if (protocole && source.protocoleDatas.length > 0) {
      let tmpProtocle = protocole.filter(
        (item) => item.nom === source.protocole
      )[0].refMetadonnees;
      let metaProtole = [];
      for (let valProtocle of tmpProtocle) {
        for (let meta of source.protocoleDatas) {
          if (valProtocle.nom === meta.nom) {
            metaProtole.push({
              id: valProtocle.id,
              nom: valProtocle.nom,
              libelle: valProtocle.libelle,
              type:
                valProtocle.nom === "source_motif_noms_fichiers"
                  ? "regex"
                  : valProtocle.type,
              value: meta.valeur,
            });
          }
        }
      }
      setProtocoleData(metaProtole);
    }
    if (protocole) {
      const uriDescription = protocole.find((i) => i.nom === source.protocole)?.uriPattern
      setUriDesc(
        uriDescription ? uriDescription : ""
      );
    }
  }, [protocole]);

  useEffect(() => {
    if (typesDonnee) {
      setTypeData(typesDonnee.map((a: any) => ({ name: a.nom })));
    }
  }, [typesDonnee]);

  const deleteMetaData = (i: number): void => {
    setMetaDatas((currTable) => {
      return [...currTable.filter((item) => item.increment != i)];
    });
  };

  const regexNom = (nomSource: string) => {
    const CheckError: Error = { ...errorForm };
    const regex: RegExp = new RegExp(
      `^${source.protocole.toLocaleLowerCase()}`
    );

    if (nomSource !== EMPTY_STRING) {
      CheckError.uri.regex = !nomSource.match(regex);
      CheckError.uri.required = false;
    }

    errorSetter(
      CheckError.uri.required,
      CheckError.uri.regex,
      CheckError.typeDeDonnee,
      CheckError.formatDeDonnee
    );
  };

  const validationFormMetaProtocole = (
    formatProtocoleData: any,
    valueProtcoleData: any
  ) => {
    if (
      formatProtocoleData?.find((i: any) => i.nom === RECURSIVE_SOURCE) &&
      !valueProtcoleData.find((i: any) => i.nom === RECURSIVE_SOURCE)
    ) {
      return formatProtocoleData?.length - 1 !== valueProtcoleData.length;
    }
    return formatProtocoleData?.length !== valueProtcoleData.length;
  };

  const errorSetter = (
    required: boolean,
    regex: boolean,
    typeDeDonnee: boolean,
    formatDeDonnee: boolean
  ) => {
    setErrorForm({
      uri: {
        required: required,
        regex: regex,
      },
      typeDeDonnee: typeDeDonnee,
      formatDeDonnee: formatDeDonnee,
    });
  };

  const check = (): void => {
    let CheckError: Error = errorForm;
    CheckError.uri.required = source.uri.trim() === EMPTY_STRING;
    CheckError.typeDeDonnee = !source.typeDeDonnee;
    CheckError.formatDeDonnee = !source.formatDeDonnee;

    let hasError =
      CheckError.uri.required ||
      CheckError.uri.regex ||
      CheckError.typeDeDonnee ||
      CheckError.formatDeDonnee;

    if (
      !metaProtocole ||
      validationFormMetaProtocole(protocoleData, metaProtocole) ||
      metaProtocole?.find((i) => i.valeur === EMPTY_STRING) ||
      metaProtocole?.find(
        (i) =>
          !regexValidator(i.valeur) && i.nom === "source_motif_noms_fichiers"
      )
    ) {
      console.log("in bad metatada");
      setErrorProtocoleData(true);
      hasError = true;
    }
    if (
      metaDatas?.find(
        (i: any) => i.value === EMPTY_STRING || i.name === EMPTY_STRING
      )
    ) {
      setErrorMetaData(true);
      hasError = true;
    }

    errorSetter(
      CheckError.uri.required,
      CheckError.uri.regex,
      CheckError.typeDeDonnee,
      CheckError.formatDeDonnee
    );

    if (validateLabels() && !hasError) {
      saveDatas();
      add();
    }
  };

  const saveDatas = (): void => {
    // case boolean variable (récursif) is not selected, you have to initialise her to false (valeur: false)
    if (
      protocoleData.find((i: any) => i.nom === RECURSIVE_SOURCE) &&
      metaProtocole.find((i: any) => i.nom === RECURSIVE_SOURCE) === undefined
    ) {
      const recursif = protocoleData.find(
        (i: any) => i.nom === RECURSIVE_SOURCE
      );
      const metaProtocoleWithRecursif = metaProtocole.concat({
        nom: recursif.nom,
        valeur: false,
      }); //id:recursif.id,      libelle:recursif.libelle,type:recursif.type,
      dispatch(setSource({ protocoleDatas: metaProtocoleWithRecursif }));
    } else {
      dispatch(setSource({ protocoleDatas: metaProtocole }));
    }
    if (metaDatas) dispatch(setSource({ CustomMetaData: metaDatas }));
    if (selectedLabels) dispatch(setSource({ selectedLabels: selectedLabels }));
  };

  return (
    <>
      <Metadonee
        errorDialog={errorDialog}
        metaDataDuplicated={newMetaIsDuplicated}
        setter={() => {
          setErrorDialog(false);
        }}
        add={(param, reset) => {
          if (!checkMetaDataDuplicated(param.name)) {
            setNewMetaIsDuplicated(false);
            reset();
            setErrorDialog(false);
            param.increment = lengthTableMetadata + 1;
            setMetaDatas((currTable) => {
              let tmp = [...currTable];
              tmp.push(param);
              return tmp;
            });
            setLengthMeta((prev) => prev + 1);
          } else {
            setNewMetaIsDuplicated(true);
          }
        }}
      />

      {typesDonnee && (
        <div
          className="contentForm"
          style={{ position: "relative", height: "68vh", overflow: "scroll" }}
        >
          <div className="formSourceExt">
            <div>
              <label
                htmlFor="uri"
                className={classNames({
                  labelSourceExterne: true,
                  "p-error":
                    (errorForm.uri.required && source.uri === EMPTY_STRING) ||
                    errorForm.uri.regex,
                })}
              >
                Uri<span className="star">*</span>
              </label>
              <InputText
                id={"uri"}
                value={source.uri}
                className={classNames({
                  "p-invalid":
                    (errorForm.uri.required && source.uri === EMPTY_STRING) ||
                    errorForm.uri.regex,
                  fieldSourceExt: true,
                })}
                placeholder={uriDesc}
                onChange={(e) => {
                  regexNom(e.target.value);
                  dispatch(
                    setSource({
                      uri: e.target.value,
                    })
                  );
                }}
              />
            </div>

            <div className="mt-3">
              <label
                htmlFor="utilisateur"
                className={classNames({
                  "p-error": false,
                  labelSourceExterne: true,
                })}
              >
                Utilisateur
              </label>
              <InputText
                id={"utilisateur"}
                value={source.utilisateur}
                className={classNames({
                  "p-invalid": false,
                  fieldSourceExt: true,
                })}
                onChange={(e) => {
                  // console.log("hey",e.target.value,"hey",e.target,e.target.value)
                  dispatch(
                    setSource({
                      utilisateur: e.target.value,
                    })
                  );
                  // setName(e.target.value)
                }}
              />
            </div>

            <div className="mt-3">
              <label
                htmlFor="motDePasse"
                className={classNames({
                  "p-error": false,
                  labelSourceExterne: true,
                })}
              >
                Mot de passe
              </label>
              <InputText
                id={"motDePasse"}
                value={source.motDePasse}
                className={classNames({
                  "p-invalid": false,
                  fieldSourceExt: true,
                })}
                type="password"
                onChange={(e) => {
                  // console.log("hey",e.target.value,"hey",e.target,e.target.value)
                  dispatch(
                    setSource({
                      motDePasse: e.target.value,
                    })
                  );
                  // setName(e.target.value)
                }}
              />
            </div>

            <div className="mt-3">
              <label
                htmlFor="organisme"
                className={classNames({
                  "p-error": false,
                  labelSourceExterne: true,
                })}
              >
                Organisme
              </label>
              <InputText
                id={"organisme"}
                value={source.organisme}
                className={classNames({
                  "p-invalid": false,
                  fieldSourceExt: true,
                })}
                onChange={(e) => {
                  // console.log("hey",e.target.value,"hey",e.target,e.target.value)
                  dispatch(
                    setSource({
                      organisme: e.target.value,
                    })
                  );
                  // setName(e.target.value)
                }}
              />
            </div>

            {protocoleData &&
              protocoleData.map((i: Metadonees) => (
                <div className="mt-3">
                  {i.type === "string" && (
                    <Text
                      name={i.libelle}
                      error={errorProtocoleData}
                      init={i?.value ? i.value : EMPTY_STRING}
                      add={(variable) => {
                        updateMetaProtocole(i.nom, variable);
                      }}
                    />
                  )}
                  {i.type === "regex" && (
                    <Regex
                      name={i.libelle}
                      error={errorProtocoleData}
                      init={i?.value ? i.value : EMPTY_STRING}
                      add={(variable) => {
                        updateMetaProtocole(i.nom, variable);
                      }}
                    />
                  )}
                  {i.type === "boolean" && (
                    <Boolean
                      name={i.libelle}
                      init={i?.value ? i.value : false}
                      add={(param) => {
                        updateMetaProtocole(i.nom, param);
                      }}
                    />
                  )}
                  {i.type.includes("choice") && (
                    <List
                      name={i.libelle}
                      init={i?.value ? { name: i.value } : null}
                      error={errorProtocoleData}
                      add={(param) => {
                        updateMetaProtocole(i.nom, param);
                      }}
                      type={i.type}
                    />
                  )}
                  {i.type === "edsChoice" ? (
                    <List
                      name={i.libelle}
                      init={i?.value ? { name: i.value } : null}
                      error={errorProtocoleData}
                      add={(param) => {
                        updateMetaProtocole(i.nom, param);
                      }}
                      type={i.type}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ))}

            <div className="grid p-fluid mt-3">
              <div className="col-6">
                <label
                  htmlFor="typeDeDonnee"
                  className={classNames({
                    "p-error":
                      errorForm.typeDeDonnee && source.typeDeDonnee === null,
                    labelSourceExterne: true,
                  })}
                >
                  Type de Donnée<span className="star">*</span>
                </label>
                <Dropdown
                  id={"typeDeDonnee"}
                  value={source.typeDeDonnee}
                  onChange={(e) => {
                    dispatch(setSource({ typeDeDonnee: e.value }));
                    dispatch(setSource({ formatDeDonnee: null }));
                    updateFormatData(e.value.name);
                  }}
                  options={typeData}
                  optionLabel="name"
                  className={classNames({
                    "p-invalid":
                      errorForm.typeDeDonnee && source.typeDeDonnee === null,
                    fieldSourceExt: true,
                  })}
                />
              </div>
              <div className="col-6 p-field">
                <label
                  htmlFor="FormatDeDonnee"
                  className={classNames({
                    "p-error":
                      errorForm.formatDeDonnee &&
                      source.formatDeDonnee === null,
                    labelSourceExterne: true,
                  })}
                >
                  Format de donnée<span className="star">*</span>
                </label>
                <Dropdown
                  disabled={source.typeDeDonnee === null}
                  id={"formatDeDonnee"}
                  value={source.formatDeDonnee}
                  onChange={(e) => {
                    dispatch(setSource({ formatDeDonnee: e.value }));
                  }}
                  options={formatData}
                  optionLabel="name"
                  className={classNames({
                    "p-invalid":
                      errorForm.formatDeDonnee &&
                      source.formatDeDonnee === null,
                    fieldSourceExt: true,
                  })}
                />
              </div>
            </div>

            <LabelsSelectors values={source.selectedLabels} />

            <div className="buttonMetaData">
              <Button
                className="p-button-text"
                type="button"
                label="AJOUTER UNE METADONNEE"
                onClick={() => {
                  setErrorDialog(true);
                }}
                icon="pi pi-plus"
              />
            </div>

            {formMetaData &&
              metaDatas.map((data: any, i) => (
                <div className="grid p-fluid mt-2">
                  <div className="col-5 p-field">
                    <label
                      htmlFor={idMetaData("name", i, data.increment)}
                      className={classNames({
                        "p-error": errorMetaData && data.name === EMPTY_STRING,
                        labelSourceExterne: true,
                      })}
                    >
                      Nom<span className="star">*</span>
                    </label>

                    <InputText
                      id={idMetaData("name", i, data.increment)}
                      className={classNames({
                        "p-invalid":
                          errorMetaData && data.name === EMPTY_STRING,
                        fieldSourceExt: true,
                      })}
                      value={
                        metaDatas.find(
                          (item) => item.increment === data.increment
                        )?.name
                      }
                      onChange={(e) => {
                        setMetaDatas((currTable) => {
                          let foundIndex = metaDatas.findIndex(
                            (x) => x.increment === data.increment
                          );
                          let tmp = [...currTable];
                          tmp[foundIndex].name = e.target.value;
                          return tmp;
                        });
                      }}
                    />
                  </div>
                  <div className="col-1 p-field text-center mt-5">=</div>
                  <div className="col-5">
                    <label
                      htmlFor={idMetaData("value", i, data.increment)}
                      className={classNames({
                        "p-error": errorMetaData && data.value == EMPTY_STRING,
                        labelSourceExterne: true,
                      })}
                    >
                      Valeur<span className="star">*</span>
                    </label>
                    <InputText
                      id={idMetaData("value", i, data.increment)}
                      className={classNames({
                        "p-invalid":
                          errorMetaData && data.value == EMPTY_STRING,
                        fieldSourceExt: true,
                      })}
                      value={
                        metaDatas.find(
                          (item) => item.increment == data.increment
                        )?.value
                      }
                      onChange={(e) => {
                        setMetaDatas((currTable) => {
                          let foundIndex = metaDatas.findIndex(
                            (x) => x.increment == data.increment
                          );
                          let tmp = [...currTable];
                          tmp[foundIndex].value = e.target.value;
                          return tmp;
                        });
                      }}
                    />
                  </div>
                  <div className="col-1 mt-4">
                    <Button
                      type="button"
                      className="p-button-outlined p-button-secondary"
                      icon="pi pi-trash"
                      onClick={() => {
                        deleteMetaData(data.increment);
                        if (id) {
                          const nom = metaDatas?.find(
                            (item) => item.increment === data.increment
                          )?.name;
                          const valeur = metaDatas?.find(
                            (item) => item.increment == data.increment
                          )?.value;
                          if (nom && valeur)
                            dispatch(
                              deleteCustomMeteData({
                                nom: nom,
                                valeur: valeur,
                              })
                            );
                        }
                      }}
                    />
                  </div>
                </div>
              ))}

            {metaDataDuplicated.length > 0 && (
              <div className="mt-2 mb-2">
                <Message
                  className="w-full"
                  severity="error"
                  content={
                    <div
                      className={
                        "flex flex-column align-items-center justify-content-center"
                      }
                    >
                      <div>Le nom d'une metadonnée doit être unique !</div>
                      <div>
                        Nom(s) de métadonnées dupliqué(s) :{" "}
                        <strong>{metaDataDuplicated.toString()}.</strong>
                      </div>
                    </div>
                  }
                />
              </div>
            )}
          </div>
        </div>
      )}

      {TypesDonneeStatus.isLoading && (
        <>
          <div className="contentForm">
            <div className="formSourceExt mr-5">{RenderLoading(10)}</div>
          </div>
        </>
      )}

      {TypesDonneeStatus.error && !TypesDonneeStatus.isLoading && (
        <ErrorSourceExterne message={"Erreur de chargement"} />
      )}

      <ButtonsNavigate
        cancel={() => {
          navigate("/library/sources");
        }}
        back={() => {
          minus();
          saveDatas();
        }}
        shouldGoNext={!!typesDonnee}
        next={() => {
          check();
        }}
      />
    </>
  );
};
